<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th jhiSortBy="billNumber">
          <span jhiTranslate="refund.refundNumber">Bill number</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th>
          <span jhiTranslate="bills.basketOrderOriginBillNumber">Bill number</span>
        </th>
        <th jhiSortBy="customer" *ngIf="tableOptions && tableOptions.isModerator && !tableOptions.focusForCustomer">
          <span jhiTranslate="bills.customer">Customer name</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="billDate">
          <span jhiTranslate="bills.billDate">Bill Date</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="price">
          <span class="no-capitalize" jhiTranslate="bills.totalAmount">Total Amount</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="paymentMethod">
          <span jhiTranslate="bills.paymentMethod">Payment Method</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr mdbTableRow *ngFor="let basketOrder of basketOrders; trackBy: trackId">
        <td>
          <span>{{ basketOrder.billNumber }}</span>
        </td>
        <td>
          <span>{{ basketOrder.basketOrderOriginBillNumber }}</span>
        </td>
        <td *ngIf="tableOptions && tableOptions.isModerator && !tableOptions.focusForCustomer">
          <a [routerLink]="['/middle/customer/' + basketOrder.customer?.id + '/data']">{{ basketOrder.fullname }}</a>
        </td>
        <td>
          <span>{{ basketOrder.billDate?.toDate() | date: 'dd/MM/yy' }}</span>
        </td>
        <td>
          <span>{{ basketOrder.price | currency: 'EUR' }}</span>
          <i
            *ngIf="LIST_REFUNDED_STATUS.NOT_REFUNDED.code !== basketOrder.refundedStatus"
            class="pl-1 fas fa-exchange-alt"
            [class.text-danger]="basketOrder.refundedStatus.code === LIST_REFUNDED_STATUS.TOTALLY_REFUNDED.code"
            [class.text-warning]="basketOrder.refundedStatus.code === LIST_REFUNDED_STATUS.PARTIALLY_REFUNDED.code"
            [mdbTooltip]="basketOrder.refundedStatus.translationKey | translate"
          ></i>
        </td>
        <td>
          <span class="d-none d-sm-table-cell">{{ basketOrder.paymentMethod.translationKey | translate }}</span>
          <span class="d-sm-none d-table-cell emojis" [mdbTooltip]="basketOrder.paymentMethod.translationKey | translate">{{ basketOrder.paymentMethod.emoji }}</span>
        </td>
        <td>
          <jhi-bary-cta *ngIf="basketOrder.id" [actions]="actions" (selectAction)="goToBill(basketOrder.id)"></jhi-bary-cta>
        </td>
      </tr>
      <tr [hidden]="basketOrders && basketOrders.length > 0">
        <td colspan="8" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="bills.noData">No bills</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
